module.exports = __webpack_public_path__ + "img/P150T_weapon_76.ccdce451.png";